import type { LoaderFunctionArgs } from "@remix-run/server-runtime";
import { ArticleComponent, articleLoader } from "./_shared/ArticleComponent";
import invariant from "invariant";

const slug = "refund-policy"
export async function loader({ request }: LoaderFunctionArgs) {
	invariant(articleLoader, "articleLoader can't be empty")
	return articleLoader(request, slug)
}
export default function RefundPolicy() {
	return <ArticleComponent />
}